import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-61f8fedc")
const _hoisted_1 = { class: "tree" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_tree = _resolveComponent("el-tree")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PageSearch, {
      formConfig: _ctx.formConfig,
      onQueryBtnClick: _ctx.handleQueryClick,
      onResetBtnClick: _ctx.handleQueryClick
    }, null, 8, ["formConfig", "onQueryBtnClick", "onResetBtnClick"]),
    _createVNode(_component_PageContent, {
      ref: "pageContentRef",
      contentConfig: _ctx.contentConfig,
      pageName: "role",
      onEditBtnClick: _ctx.handleEditData,
      onNewBtnClick: _ctx.handleNewData
    }, null, 8, ["contentConfig", "onEditBtnClick", "onNewBtnClick"]),
    _createVNode(_component_PageModal, {
      ref: "pageModalRef",
      pageName: "role",
      modalConfig: _ctx.modalConfig,
      defaultInfo: _ctx.defaultInfo,
      otherInfo: _ctx.otherInfo,
      onAfterCreateData: _ctx.handleResetClick,
      onAfterdeleteData: _ctx.handleResetClick
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_tree, {
            ref: "elTreeRef",
            data: _ctx.menuList,
            "show-checkbox": "",
            "node-key": "id",
            props: { children: 'children', label: 'name' },
            onCheck: _ctx.handleCheckChange
          }, null, 8, ["data", "onCheck"])
        ])
      ]),
      _: 1
    }, 8, ["modalConfig", "defaultInfo", "otherInfo", "onAfterCreateData", "onAfterdeleteData"])
  ]))
}